import React from 'react';
import { useNotification, usePayLink } from '../../../firebase/api/user';
import styled from 'styled-components';
// import isWeb from '../../../utils/isWeb';
// const shell = isWeb ? null : window.require('electron').shell;

const Modal = styled.div`
  display: block;
  background: #fff;
`;

const Text = styled.div`
  background: #fff;
  padding: 20px 20px 0;
  font-weight: bold;
`;

const Wrapper = styled.div`
  position: fixed;
  z-index: 9999999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  box-shadow: 0, 0, 6px, 0 rgba(0.5);
  background: rgba(0, 0, 0, 0.5);
`;

const PayButton = styled.div`
  cursor: pointer;
  width: 200px;
  margin: 20px auto;
  text-align: center;
  transition: 0.3s ease-in-out;
  background-image: linear-gradient(
    to right,
    rgb(31, 162, 255) 0%,
    rgb(18, 216, 250) 51%,
    rgb(31, 162, 255) 100%
  );
  padding: 10px;
  color: #fff;
  background-size: 200%;
  &:hover {
    background-position: right center;
  }
`;

const Notification: React.FC = () => {
  const { notification } = useNotification();
  const { link } = usePayLink();

  const renederHtml = () => {
    return <div className="content" dangerouslySetInnerHTML={{ __html: notification }}></div>;
  };

  // const pay = () => {
  //   shell ? shell.openExternal(link) : window.location.replace(link);
  // };

  return (
    <>
      {renederHtml()}
      {link && (
        <Wrapper>
          <Modal>
            <Text>Срок пробного периода подошел к концу</Text>
            {/* <PayButton onClick={pay}>Оплатить подписку</PayButton> */}
          </Modal>
        </Wrapper>
      )}
    </>
  );
};

export default Notification;
